export const ACCOUNT_PARAMS = "ACCOUNT_PARAMS"
export const ACCOUNT_PARAMS_SUCCESS = "ACCOUNT_PARAMS_SUCCESS"
export const ACCOUNT_PARAMS_ERROR = "ACCOUNT_PARAMS_ERROR"
